import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var SvgDoubleArrowLeft16 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (jsxs("svg", __assign({ width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsx("title", __assign({ id: titleId }, { children: title })) : null, jsxs("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [jsx("path", { fill: "none", d: "M0 .5h16v16H0z" }), jsx("path", { d: "m11.5 12.5-4-4 4-4m-4 8-4-4 4-4", strokeLinecap: "square", stroke: "currentColor" })] }))] })));
};

export { SvgDoubleArrowLeft16 as default };
